import React, { useState, useEffect, FC, ReactNode } from 'react';
import { TextArea } from 'devextreme-react';

export interface AEATextAreaProps {
    maxLength?: number,
    defaultValue?: string
    id: string;
    readOnly: boolean;
    placeholder: string;
    requiredErrorMessage?: string;
    required?: boolean;
    multiple?: boolean;
    onValueChanged?(value: any): void;
    children: ReactNode;
    value?: string;
}

const AEATextArea: FC<AEATextAreaProps> = (props: AEATextAreaProps) => {
    const [textAreaValue, setTextAreaValue] = useState(props.defaultValue);
    const [totalCharters, setTotalCharters] = useState(props.defaultValue?.length || 0);

    useEffect(() => {
        setTextAreaValue(props.value)
        setTotalCharters(props.value?.length || 0)
    }, [props.value]);

    return (
        <div>
            {props.maxLength !== undefined ?
                <div className="contadorCaracteres">{`${totalCharters} / ${props.maxLength}`}</div> : <div></div>
            }
            <TextArea
                maxLength={props.maxLength ? props.maxLength : null}
                defaultValue={props.defaultValue}
                value={textAreaValue}
                key={props.id}
                id={props.id}
                valueChangeEvent="keyup"
                onValueChanged={props.onValueChanged}
                readOnly={props.readOnly}
                placeholder={props.placeholder}>
            </TextArea>
        </div>

    )
}

export default AEATextArea;